<template>
  <div class="main-container invoices-table-height">
    <div style="width: 100%">
      <el-input
        style="max-width: 200px"
        placeholder="Search Invoices"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        @on-selected-rows-change="selectionChanged"
        :columns="isACustomer ? customerTableOptions : tableOptions"
        :rows="invoiceList"
        :isLoading="isLoadingVGT"
        :search-options="{
          enabled: true,
          searchFn: searchTable,
          externalQuery: searchTerm
        }"
        :pagination-options="{ enabled: true }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- {{props.row}} -->
          <div>
            <span v-if="props.column.field == 'name'">
              {{
                props.row["payload"]["user"]["firstName"] &&
                props.row["payload"]["user"]["lastName"]
                  ? `${props.row["payload"]["user"]["firstName"]} ${props.row["payload"]["user"]["lastName"]}`
                  : `${props.row["user"]["firstName"]} ${props.row["user"]["lastName"]}`
              }}
            </span>
            <span
              v-if="
                props.column.field == 'type' ||
                  props.column.field == 'invoiceType'
              "
            >
              {{
                props.row["type"] ||
                props.row["type"] == "autoMonthlySubscription"
                  ? "subscription"
                  : props.row["payload"]["invoiceType"]
              }}
            </span>
            <span v-if="props.column.field == 'invoiceNo'">
              {{ props.row["invoiceNo"] }}
            </span>
            <span v-else-if="props.column.field == 'paymentModel'">
              {{ props.row["paymentMode"] }}
            </span>
            <span v-else-if="props.column.field == 'price'">
              {{ "₦"
              }}{{
                numberWithCommas(
                  props.row["payload"]["packageType"]
                    ? props.row["payload"]["packageType"]["price"]
                    : props.row["payload"]["invoiceTotalAmount"]
                    ? props.row["payload"]["invoiceTotalAmount"]
                    : props.row["payload"]["amount"] || "0.0"
                )
              }}
            </span>
            <span v-else-if="props.column.field == 'date'">
              {{ new Date(props.row["createdAt"]).toDateString() }}
            </span>
            <span
              v-if="props.column.field == 'status'"
              :class="
                props.row['ispayed']
                  ? 'badge badge-success'
                  : 'badge badge-danger'
              "
              >{{ props.row["ispayed"] ? "Paid" : "Not Paid" }}</span
            >
            <span v-if="props.column.field == 'action'">
              <b-button
                style="background-color: #1a93ca; color: white; border: none"
                type="primary"
                @click="viewStatus(props.row)"
                >View</b-button
              >
            </span>
          </div>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
import { mapGetters } from "vuex";
import moment from "moment";
import { Select, Button, Autocomplete, Form, FormItem } from "element-ui";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  data() {
    return {
      selectedRow: null,
      searchTerm: "",
      isLoadingVGT: true,
      items: items,
      tableOptions: [
        {
          field: "name",
          label: "Name",
          sortable: "true"
        },
        {
          field: "type",
          label: "Invoice Type",
          sortable: "true"
        },
        {
          field: "invoiceNo",
          label: "Invoice Number",
          sortable: "true"
        },
        {
          field: "paymentModel",
          label: "Payment Model",
          sortable: "true"
        },
        // {
        //   field: "packageName",
        //   label: "Package Name",
        //   sortable: "true"
        // },
        {
          field: "price",
          label: "Amount",
          sortable: "true"
        },
        {
          field: "date",
          label: "Date",
          sortable: "true"
        },
        {
          field: "status",
          label: "Status",
          sortable: "true"
        },
        {
          field: "action",
          label: "Action",
          sortable: "true"
        }
      ],
      customerTableOptions: [
        {
          field: "name",
          label: "Name",
          sortable: "true"
        },
        {
          field: "type",
          label: "Invoice Type",
          sortable: "true"
        },
        {
          field: "invoiceNo",
          label: "Invoice Number",
          sortable: "true"
        },
        // {
        //   field: "packageName",
        //   label: "Package Name",
        //   sortable: "true"
        // },
        {
          field: "paymentModel",
          label: "Payment Model",
          sortable: "true"
        },
        {
          field: "price",
          label: "Amount",
          sortable: "true"
        },
        {
          field: "date",
          label: "Date",
          sortable: "true"
        },

        {
          field: "action",
          label: "Action",
          sortable: "true"
        }
      ],
      invoiceList: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },
  components: {},
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
    isACustomer: {
      get() {
        if (this.$can("am", "customer")) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  methods: {
    selectionChanged(e) {
      if (e.selectedRows.length <= 0) {
        this.selectedRow = null;
        return;
      }
      let obj = e.selectedRows;
      this.selectedRow = Object.keys(obj).map(key => obj[key].id);
      return;
    },
    viewStatus(row) {
      // console.log(row);
      this.$router.push({
        //path: `/invoices/:${row.id}`,
        name: "singleinvoice",
        params: {
          single: row.id
        }
      });
    },
    numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    searchTable(invoiceList, tableOptions, cellValue, searchTerm) {
      return (
        Object.values(invoiceList)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    viewMaintenance(maintenance) {
      this.selectedMaintenance = maintenance;
      this.showOffCanvas = true;
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      // console.log('userID', userId);
      let realm = this.getUserSession.realm;
      let filter;
      filter = {
        order: "id DESC",
        where: {
          or: [{ type: "subscription" }, { type: "autoMonthlySubscription" }]
        },
        limit: 150,
        include: ["user"]
      };
      if (this.$can("am", "customer")) {
        filter = {
          order: "id DESC",
          where: {
            and: [
              { userId: userId },
              {
                or: [
                  { type: "subscription" },
                  { type: "autoMonthlySubscription" }
                ]
              }
            ]
          },
          limit: 150,
          include: ["user"]
        };
      }
      let url = `/invoices?filter=${JSON.stringify(filter)}`;
      //let url = `/maintenance?filter={"where":{"assignedTo":${userId}},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // if (this.$can("am", "engineer")) {
      //     url = `/maintenance?filter={"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // } else if (this.$can("manage", "customer")) {
      //     url = `/maintenance?filter={"where":{"realm":{"$regex" :"^${realm}"}},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // } else if (this.$can("read", "all")) {
      //     url = `/maintenance?filter={"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // }
      httpUtils.instance
        .get(url)
        .then(response => {
          console.log("===============================");

          // console.log(response);

          this.invoiceList = response.data;
          this.isLoadingVGT = false;
          // this.invoiceList.map(i => {
          //   console.log(i);
          // });
        })
        .catch(error => {
          this.errors = "Error occured at our end!";
          this.invoiceList = "";
        });
    }
  },
  async mounted() {
    this.init();
  }
};
</script>
<style scoped>
/* .statusLabel {
  font-size: 8pt;
  border-radius: 10pt !important;
  padding: 0pt;
  text-transform: capitalize;
} */

.badge-success {
  background: #35ae47;
}

.badge-danger {
  background-color: #eb3b48;
}

.badge {
  min-width: 123px;
  display: inline-block;
  font-weight: normal;
  text-transform: capitalize;
  font-size: 8pt;
  letter-spacing: 0.0625rem;
  color: #fff;
  border-radius: 10pt;
}
.invoices-table-height {
  height: calc(100vh - 240px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/invoices/invoices.vue